import React from "react";
type PendingProps = {
  label: string;
  className?: string;
};
export function Pending({
  label,
  className = ""
}: PendingProps) {
  return <span className={`inline-flex items-center gap-1.5 rounded-md border border-dashed border-sand-deep bg-sand-light px-2 py-0.5 font-sans text-xs font-semibold normal-case tracking-normal text-forest-deep ${className}`} data-id="element-230" data-mp="1l2cnhk6785gf">
      Pending: {label}
    </span>;
}